export interface SelectionStatus {
  id: string;
  toggle: () => SelectionStatus;
  start: () => SelectionStatus;
  final: () => SelectionStatus;
  isChecked: boolean;
  isIndeterminate: boolean;
}
